import React from 'react'
import PropTypes from 'prop-types'
import { bem } from '@argos/utils'

import MinimizeIcon from '../Common/Icons/Minimize'
import ChevronIcon from '../Common/Icons/Chevron'
import CancelIcon from '../Common/Icons/Cancel'

const cn = bem({ prefix: 'lc-', block: 'header' })

export class Header extends React.Component {
  static propTypes = {
    onToggleMinimized: PropTypes.func.isRequired,
    onShowExitPrompt: PropTypes.func.isRequired,
  }

  render() {
    const { onShowExitPrompt, onToggleMinimized } = this.props

    return (
      <header id='chatHeading' className={cn()} data-test={cn('')}>
        <button type='button' className={cn('close-btn')} data-test={cn('close-btn')} onClick={onShowExitPrompt}>
          <span className='sr-only'>End Chat</span>
          <span className={cn('close-wrapper')}>
            <CancelIcon className={cn('cancel-icon')} />
          </span>
        </button>

        <h1 className={cn('title')}>Live chat</h1>

        <button type='button' className={cn('minimize-btn')} data-test={cn('minimize-btn')} onClick={onToggleMinimized}>
          <span className='sr-only'>Minimize Live Chat</span>
          <span className={cn('minimize-wrapper')}>
            <MinimizeIcon className={cn('minimize-icon')} />
            <ChevronIcon className={cn('chevron-icon')} />
          </span>
        </button>
      </header>
    )
  }
}

export default Header
